import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-addcase-progress',
    templateUrl: './addcase-progress.component.html',
    styleUrls: ['./addcase-progress.component.scss'],
    standalone: false
})
export class AddcaseProgressComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
